import React, { useState, useEffect, useRef } from 'react';
import { Navbar as BootstrapNavbar, Container, Nav } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import logo from '../../assets/logo.png';
import './Navbar.css';

function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const navbarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    await logout();
    setExpanded(false);
    navigate('/login');
  };

  const getNavItems = () => {
    //console.log('user:', user);
    if (!user) {
      return (
        <>
          <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}>首頁</Nav.Link>
          <Nav.Link as={Link} to="/login" onClick={() => setExpanded(false)}>登入</Nav.Link>
          <Nav.Link as={Link} to="/register" onClick={() => setExpanded(false)}>註冊</Nav.Link>
        </>
      );
    }
    //console.log('user.role:', user.role);
    switch (user.role) {
      case 'ADMIN':
        return (
          <>
            <Nav.Link as={Link} to="/admin" onClick={() => setExpanded(false)}>首頁</Nav.Link>
            <Nav.Link as={Link} to="/articles/manage" onClick={() => setExpanded(false)}>文章管理</Nav.Link>
            <Nav.Link as={Link} to="/admin/evaluation-database" onClick={() => setExpanded(false)}>評估資料庫</Nav.Link>
            <Nav.Link as={Link} to="/admin/instructor-evaluations" onClick={() => setExpanded(false)}>教練評估</Nav.Link>
            <Nav.Link as={Link} to="/admin/users" onClick={() => setExpanded(false)}>用戶管理</Nav.Link>
            <Nav.Link onClick={() => { handleLogout(); setExpanded(false); }}>登出</Nav.Link>
          </>
        );
      case 'COACH':
        return (
          <>
            <Nav.Link as={Link} to="/coach" onClick={() => setExpanded(false)}>首頁</Nav.Link>
            <Nav.Link as={Link} to="/articles/manage" onClick={() => setExpanded(false)}>文章管理</Nav.Link>
            <Nav.Link as={Link} to="/coach/schedule" onClick={() => setExpanded(false)}>行程管理</Nav.Link>
            <Nav.Link as={Link} to="/coach/booking" onClick={() => setExpanded(false)}>預約管理</Nav.Link>
            <Nav.Link as={Link} to="/coach/evaluation" onClick={() => setExpanded(false)}>學員評量</Nav.Link>
            <Nav.Link onClick={() => { handleLogout(); setExpanded(false); }}>登出</Nav.Link>
          </>
        );
      case 'STUDENT':
        return (
          <>
            <Nav.Link as={Link} to="/student" onClick={() => setExpanded(false)}>首頁</Nav.Link>
            <Nav.Link as={Link} to="/student/history" onClick={() => setExpanded(false)}>預約記錄</Nav.Link>
            <Nav.Link as={Link} to="/student/booking" onClick={() => setExpanded(false)}>課程預約</Nav.Link>
            <Nav.Link onClick={() => { handleLogout(); setExpanded(false); }}>登出</Nav.Link>
          </>
        );
      default:
        return null;
    }
  };

  const getBrandLink = () => {
    if (!user) return '/';
    switch (user.role) {
      case 'ADMIN':
        return '/admin';
      case 'COACH':
        return '/coach';
      case 'STUDENT':
        return '/student';
      default:
        return '/';
    }
  };

  const getBrandText = () => {
    //return '雪季文章分享';
    if (!user) return '雪季文章分享';
    
    const path = window.location.pathname;
    let brandText = '';
    let pageText = '';
    
    switch (user.role) {
      case 'ADMIN':
        brandText = '管理系統';
        if (path === '/admin/users') {
          pageText = '/ 用戶管理';
        } else if (path === '/admin') {
          pageText = '/ 首頁';
        } else if (path === '/articles/manage') {
          pageText = '/ 文章管理';
        } else if (path === '/admin/evaluation-database') {
          pageText = '/ 評估資料庫';
        } else if (path === '/admin/instructor-evaluations') {
          pageText = '/ 教練評估';
        }
        break;
      case 'COACH':
        brandText = '教練系統';
        if (path === '/coach') {
          pageText = '/ 首頁';
        } else if (path === '/articles/manage') {
          pageText = '/ 文章管理';
        } else if (path === '/coach/schedule') {
          pageText = '/ 行程管理';
        } else if (path === '/coach/booking') {
          pageText = '/ 預約管理';
        } else if (path === '/coach/evaluation') {
          pageText = '/ 學員評量';
        }
        break;
      case 'STUDENT':
        brandText = '學員系統';
        if (path === '/student') {
          pageText = '/ 首頁';
        } else if (path === '/student/history') {
          pageText = '/ 預約記錄';
        } else if (path === '/student/booking') {
          pageText = '/ 課程預約';
        }
        break;
      default:
        brandText = '雪季文章分享';
    }

    return (
      <>
        <span className="brand-main">{brandText}</span>
        {pageText && <span className="brand-page">{pageText}</span>}
      </>
    );

  };

  return (
    <BootstrapNavbar 
      expand="lg" 
      bg="dark" 
      variant="dark"
      expanded={expanded}
      onToggle={setExpanded}
      ref={navbarRef}
      className="custom-navbar"
    >
      <Container>
        <BootstrapNavbar.Brand 
          as={Link} 
          to={getBrandLink()}
          onClick={() => setExpanded(false)}
          className="d-flex align-items-center"
        >
          {/*
          <img
            src={logo}
            width="30"
            height="30"
            className="d-inline-block align-top me-2"
            alt="ASA滑雪 Logo"
          />
          */}
          {getBrandText()}
        </BootstrapNavbar.Brand>
        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {getNavItems()}
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
}

export default Navbar; 